import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { GetTokboxToken } from '../../../connection/opentok';
import OpenTok from '../../../utils/video/opentok-connection';
import * as SessionActions from '../../../stores/actions/session';
import { GreenroomState } from '../../../stores/types/types';

interface IPhonePreviewProps {
	onVideoConnected?: Function
}

export default function IPhonePreview(props: IPhonePreviewProps) {
	const user = useSelector((state: GreenroomState) => state.SessionReducer.user);
	const iosOpentokSession = useSelector((state: GreenroomState) => state.SessionReducer.iosOpentokSession);
	const expectIosStream = useSelector((state: GreenroomState) => state.SessionReducer.expectIosStream);
	const [stream, setStream] = useState<MediaStream | null>(null);
	const opentok = useRef<OpenTok | null>(null);
	const iosPreviewVideo = useRef<HTMLVideoElement | null>(null);
	const dispatch = useDispatch();

	function streamSubscribed(event: any) {
		setStream(event.element.srcObject);
		dispatch(SessionActions.setExpectIosStream(true));
	}

	function bitrates() { }

	async function streamAdded(event: any) {
		await opentok.current?.subscribeToStream(event.stream);
	}

	function streamRemoved(event: any) {
		setStream(null);
		dispatch(SessionActions.setExpectIosStream(false));
	}

	async function startup() {
		if (user && iosOpentokSession) {
			const tokboxToken = await GetTokboxToken(iosOpentokSession);
			opentok.current = new OpenTok(
				user,
				iosOpentokSession,
				tokboxToken.token,
				() => {},
				() => {},
				streamSubscribed,
				bitrates,
			);
			opentok.current.onStreamAdded(streamAdded);
			opentok.current.onStreamRemoved(streamRemoved);
			opentok.current.subscribeOnly();
		}
	}

	useEffect(() => {
		if (iosOpentokSession && !opentok.current) {
			startup();
		}
	}, [iosOpentokSession]);

	useEffect(() => () => {
		if (opentok.current) opentok.current.stop();
	}, []);

	useEffect(() => {
		if (iosPreviewVideo && iosPreviewVideo.current && stream) {
			iosPreviewVideo.current.srcObject = stream;
			iosPreviewVideo.current.volume = 0;
			iosPreviewVideo.current.play().catch((e) => console.error(e));
			props.onVideoConnected?.();
		}
	}, [expectIosStream, stream]);

	return (
		<div className={[
			'image-container',
			'presenter',
			'app-entry-video-wrapper-outer',
			'ios-entry-wrapper-outer',
			expectIosStream ? 'ios-preview-stream-wrapper' : ''].join(' ')}>
			{!expectIosStream && <div className="iphone-image-wrapper image-wrapper"></div>}
			{expectIosStream && (
				<div className="app-entry-video-wrapper">
					<div className="app-entry-video-container">
						<div className="app-entry-video-container-wrapper">
							<video autoPlay ref={iosPreviewVideo}/>
						</div>
					</div>
				</div>
			)}
		</div>
	);
}
